import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const CMCHistory = () => {
  useEffect(() => {
    document.title = "CMC History-  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> About Us </li>
          <li>CMC History </li>
        </ul>
      </div>
      <div class="innersec cmc-history-page">
        <div class="container">
          <h1>OUR HISTORY</h1>
          <h3>CARMEL — A JOURNEY OF FAITH, EDUCATION AND SERVICE</h3>
          <div class="cmc-intro">
            <div class="row align-items-center">
              <div class="col-lg-5">
                <div class="cmc-intro-badge">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/Mother.jpg"
                    alt="Congregation of the Mother of Carmel"
                  />
                </div>
              </div>
              <div class="col-lg-7">
                <div class="cmc-content">
                  <p>
                    The history of <strong>St. Peter’s Convent School, Sector 88, Greater Faridabad</strong>, is part of a much larger story—a story that began centuries ago on <strong>Mount Carmel in the Holy Land</strong> and eventually found a distinctive expression in India through the <strong>Congregation of the Mother of Carmel (CMC)</strong>.
                  </p>
                  <p>
                    Our school is administered by the Sisters of the <strong>Congregation of the Mother of Carmel (CMC)</strong>, whose educational mission has been shaped by more than 150 years of service to the Church and society. Founded in India in <strong>1866</strong>, CMC has grown into a worldwide congregation dedicated particularly to education, human formation, the empowerment of women and children, and service to society.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="cmc-section-heading">
            <h2>FROM MOUNT CARMEL TO CMC</h2>
          </div>
          <div class="cmc-feature-card">
            <div class="cmc-feature-number">01</div>
            <div class="cmc-content">
              <p>
                The Carmelite tradition traces its spiritual roots to <strong>Mount Carmel</strong>, inspired by the Prophet Elijah and centered on prayer, contemplation and service. <strong>Our Lady of Mount Carmel</strong>, Mother and Patroness of Carmel, remains the guiding inspiration of the Carmelite family. Carmelite missionaries brought this rich spiritual heritage to India in the <strong>17th century</strong>, contributing to the growth of the Church and society, particularly in Kerala.
              </p>
              <p>
                <strong>St. Kuriakose Elias Chavara (1805–1871)</strong>, an Indian priest, visionary educator and social reformer, dreamed of a religious congregation for women dedicated to prayer, education and service. <strong>Fr. Leopold Beccaro OCD (1837–1914)</strong>, an Italian Discalced Carmelite missionary, shared and supported this vision. Together, they founded the <strong>Congregation of the Mother of Carmel (CMC) on 13 February 1866 at Koonammavu, Kerala</strong>. From this humble beginning grew a mission dedicated to <strong>faith, education, human formation and service</strong>.
              </p>

            </div>
          </div>

          <div class="row cmc-founder-row">
            <div class="col-lg-6">
              <div class="cmc-founder-card">
                <div class="cmc-founder-top">
                  <div class="cmc-founder-icon">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/KURIAKOSE.jpg"
                      className="img-fluid"
                      alt="SPCSH"
                    />
                  </div>
                  <div>
                    <span>ST. KURIAKOSE ELIAS CHAVARA</span>
                    <strong>(1805–1871)</strong>
                  </div>
                </div>
                <h3>A Visionary of Education and Human Formation</h3>
                <p>
                  The story of CMC cannot be understood without <strong>St. Kuriakose Elias Chavara (1805–1871)</strong>.
                </p>
                <p>
                  A priest, visionary, educator, social reformer and pioneer of religious life in India, St. Chavara believed that education was essential for the transformation of individuals and society.
                </p>
                <p>
                  His educational vision was remarkably progressive for his time. In <strong>1846</strong>, he established a Sanskrit school at Mannanam, and in <strong>1864</strong> he promoted the principle popularly expressed as <strong>“a school for every church”</strong>, encouraging the establishment of schools alongside churches and monasteries.
                </p>
                <p>
                  He recognised particularly the need for the <strong>education and formation of women and children</strong>. His dream was to establish a religious community of women who would combine a life of prayer with education, catechesis, moral formation and service.That dream eventually became reality at Koonammavu, Kerala.
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="cmc-founder-card">

                <div class="cmc-founder-top">
                  <div class="cmc-founder-icon">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/LEOPOLD.png"
                      className="img-fluid"
                      alt="SPCSH"
                    />
                  </div>

                  <div>
                    <span>FR. LEOPOLD BECCARO OCD</span>
                    <strong>(1837–1914)</strong>
                  </div>
                </div>

                <h3>The Carmelite Who Helped Give Form to the Vision</h3>

                <p>
                  <strong>Rev. Fr. Leopold Beccaro OCD (1837–1914)</strong> was an Italian Discalced Carmelite missionary and a man of deep prayer and apostolic zeal.
                </p>

                <p>
                  His meeting and spiritual friendship with St. Kuriakose Elias Chavara proved decisive in the history of CMC. Their conversations and shared vision helped shape the idea of establishing a congregation for women in Kerala.
                </p>

                <p>
                  Fr. Leopold understood that the women religious would not only pursue their own spiritual growth but would also serve society through <strong>education, catechesis, moral formation and practical training</strong>, particularly for girls and women.
                </p>

                <p>
                  He supported the establishment of the new religious community and contributed significantly to its Carmelite spiritual formation.
                </p>

              </div>
            </div>

          </div>


          <div class="cmc-vision-box">
            <span>THE FOUNDATION OF CMC</span>

            <p>
              Thus, the foundation of CMC emerged from the meeting of two remarkable spiritual traditions:
            </p>

            <div class="cmc-vision-grid">
              <div>
                <strong>The Indian vision of St. Kuriakose Elias Chavara</strong>
              </div>

              <div class="cmc-vision-plus">+</div>

              <div>
                <strong>The Carmelite missionary tradition of Fr. Leopold Beccaro OCD.</strong>
              </div>
            </div>

            <p>
              Together, they opened a new chapter in the history of women's religious life and education in India.
            </p>
          </div>


          <div class="cmc-section-heading center-heading">
            <span>OUR TIMELINE</span>
            <h2>THE JOURNEY OF CMC</h2>
          </div>

          <div class="cmc-timeline">
            <div class="cmc-timeline-item">
              <div class="cmc-timeline-date">
                <strong>1866</strong>
              </div>
              <div class="cmc-timeline-dot"></div>
              <div class="cmc-timeline-content">
                <span>THE BIRTH OF CMC</span>
                <h3>13 February 1866</h3>
                <p>
                  On <strong>13 February 1866</strong>, at <strong>Koonammavu, Kerala</strong> St. Kuriakose Elias Chavara, with the cooperation of Fr. Leopold Beccaro OCD, founded the congregation that began as the <strong>Third Order of Carmelites Discalced</strong> and later became the <strong>Congregation of the Mother of Carmel (CMC)</strong>. It is recognised as the <strong>first indigenous religious congregation for women in the Syro-Malabar Church</strong>.
                </p>
                <p>
                  From these humble beginnings grew a congregation that would eventually serve thousands of people through schools, colleges, hospitals, social-service institutions, pastoral ministries and other apostolic works.
                </p>
              </div>
            </div>
            <div class="cmc-timeline-item">
              <div class="cmc-timeline-date">
                <strong>1872</strong>
              </div>
              <div class="cmc-timeline-dot"></div>
              <div class="cmc-timeline-content">
                <span>EDUCATION BEGINS</span>
                <h3>School at Koonammavu, Kerala </h3>
                <p>
                  In <strong>1872</strong>, a school was started at Koonammavu, Kerala marking one of the early expressions of the congregation's educational mission.
                </p>
                <p>
                  The mission gradually expanded beyond Kerala. CMC communities and educational institutions spread to different parts of India and later to other countries.
                </p>
                <p>
                  The congregation's educational mission reflects the vision of its founding fathers: <strong>education is not merely the transmission of knowledge; it is the formation of the whole person.</strong>
                </p>
                <p>
                  Academic excellence, character, faith, discipline, compassion, responsibility and service therefore remain inseparable elements of the CMC educational tradition.
                </p>
              </div>
            </div>
          </div>
          <div class="cmc-mission-box">
            <div class="row align-items-center">
              <div class="col-lg-4">
                <div class="cmc-mission-title">
                  <span>THE CMC EDUCATIONAL MISSION</span>
                  <h2>Education for the Whole Person</h2>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="cmc-content cmc-white-content">
                  <p className="white">
                    For more than <strong>150 years</strong>, the Congregation of the Mother of Carmel (CMC) has played a pivotal role in the field of <strong>education</strong>, alongside its ministries in healthcare, pastoral service, social development and other areas of human welfare. Through hundreds of schools, colleges, teacher-training institutions, professional institutions and educational centers in India and abroad, CMC has touched generations of lives.
                  </p>
                  <p className="white">
                    CMC education seeks the <strong>holistic development of every individual</strong>, nurturing intellectual excellence alongside moral, spiritual, emotional and social growth. It upholds the dignity of every child and promotes an environment of <strong>faith, freedom, discipline, compassion and responsibility</strong>. Education is viewed not merely as the pursuit of academic achievement, but as a means of forming <strong>conscientious, competent and compassionate human beings</strong>. Special attention is given to character formation, social responsibility, service to others and respect for human dignity. Inspired by the vision of <strong>St. Kuriakose Elias Chavara and Fr.Leopold Beccaro</strong>, CMC continues to believe that education is a powerful instrument for transforming individuals, families and society.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="cmc-school-section">
            <div class="cmc-section-heading">
              <span>ST. PETER'S CONVENT SCHOOL</span>
              <h2>A Young Institution with a Centuries Legacy</h2>
            </div>
            <div class="row align-items-center">
              <div class="col-lg-8">
                <div class="cmc-content">
                  <p>
                    It is within this rich historical and spiritual tradition that <strong>St. Peter's Convent School, Sector 88, Greater Faridabad</strong>, began its journey. St. Peter's Convent School is administered by the <strong>Sisters of the Congregation of the Mother of Carmel (CMC)</strong>.
                  </p>
                  <p>
                    The school was <strong>established in 2013</strong> and opened its doors on <strong>4 April 2013</strong>. It is affiliated with the <strong>Central Board of Secondary Education (CBSE), New Delhi</strong>, and is located in Sector 88, Greater Faridabad, Haryana.
                  </p>
                  <p>
                    Though the school is young in years, its educational philosophy stands upon a heritage that reaches back more than <strong>eight centuries of Carmelite tradition</strong> and more than <strong>160 years of CMC's institutional history</strong>.
                  </p>
                  <p>
                    The school therefore sees itself not merely as a place of academic instruction but as a living expression of the CMC educational mission—a mission that seeks to <strong>inform, form and transform</strong> young lives.
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="cmc-established">
                  <span>ESTABLISHED</span>
                  <strong>2013</strong>
                  <small>4 APRIL 2013</small>
                </div>
              </div>
            </div>
          </div>
          <div class="cmc-legacy">
            <div class="cmc-section-heading center-heading">
              <span>OUR LEGACY, OUR RESPONSIBILITY</span>
              <h2>Our Legacy, Our Responsibility</h2>
            </div>
            <div class="cmc-content text-center">
              <p>
                From the prayerful hermits of <strong>Mount Carmel</strong>, to the missionaries who crossed the seas to <strong>India</strong>, from the vision of <strong>St. Kuriakose Elias Chavara</strong> and the dedication of <strong>Fr. Leopold Beccaro</strong>, to the first four women who began the CMC journey at <strong>Koonammavu, Kerala in 1866</strong>, the story of Carmel has always been a story of faith expressed through action.
              </p>
              <h3>St. Peter's Convent School is a young chapter in this long story.</h3>
              <p>
                Our campus in Greater Faridabad may be contemporary, our classrooms may look towards the future, and our students may belong to a new generation—but the values we seek to cultivate have deep roots:
              </p>
            </div>
            <div class="cmc-values">
              <div class="cmc-value-card">
                <i class="bi bi-stars"></i>
                <strong>Faith with reason.</strong>
              </div>
              <div class="cmc-value-card">
                <i class="bi bi-book"></i>
                <strong>Knowledge with wisdom.</strong>
              </div>
              <div class="cmc-value-card">
                <i class="bi bi-heart"></i>
                <strong>Discipline with compassion.</strong>
              </div>
              <div class="cmc-value-card">
                <i class="bi bi-award"></i>
                <strong>Excellence with humility.</strong>
              </div>
              <div class="cmc-value-card">
                <i class="bi bi-person-check"></i>
                <strong>Freedom with responsibility.</strong>
              </div>
              <div class="cmc-value-card">
                <i class="bi bi-people"></i>
                <strong>Education with service.</strong>
              </div>
            </div>
            <div class="cmc-content text-center cmc-final-text">
              <p>
                Inspired by <strong>Our Lady of Mount Carmel</strong>, guided by the vision of <strong>St. Kuriakose Elias Chavara</strong>, and enriched by the Carmelite spirit handed down through generations of CMC sisters, <strong>St. Peter's Convent School</strong> continues the mission of educating young minds and forming responsible human beings who can serve God, humanity and society.
              </p>
            </div>
            <div class="cmc-journey">
              <div>From Mount Carmel to Koonammavu, Kerala.</div>
              <div>From Koonammavu, Kerala to India.</div>
              <div>From India to the world.</div>
              <div>And from that legacy to Greater Faridabad.</div>
              <strong>The journey continues.</strong>
            </div>
          </div>
          <div class="cmc-sayings">
            <div class="cmc-section-heading center-heading">
              <span>WORDS OF WISDOM</span>
              <h2>Sayings of Saint Kuriakose Elias Chavara to Children</h2>
            </div>
            <div class="cmc-main-quote">
              <i class="bi bi-quote"></i>
              <p className="white">
                “<strong>The children are treasures entrusted to the families by God to sanctify their souls with his precious blood, and make them His ministers in this world, and to return them to Him on the day of final Judgment.</strong>” St. Chavara
              </p>
            </div>
            <div class="cmc-sayings-grid">
              <div><strong>Children, you are God’s investment in the hands of your parents.</strong></div>
              <div><strong>The Children who have love of God and fear of God will love and respect their parents</strong></div>
              <div><strong>Trust your mother; God will hear the mother’s request like the baby’s request.</strong></div>
              <div><strong>Wisdom and purity should be spiritual food, like food for natural growth.</strong></div>
              <div><strong>Go to school regularly and recall what is taught during the week</strong></div>
              <div><strong>Laziness fosters evil habits.</strong></div>
              <div><strong>Let your friends be those who love God.</strong></div>
              <div><strong>Good friends will make you good.</strong></div>
              <div><strong>Keeping of bad books is like hiding fire in straw.</strong></div>
              <div><strong>Regular reading of good books and meditating on it will illumine the mind.</strong></div>
              <div><strong>Attain punctuality by means of a regular time-table.</strong></div>
              <div><strong>You angels will be turned to devils, if you fall into evil situation.</strong></div>
              <div><strong>You ought to reach home before evening and take part in the evening prayers.</strong></div>
              <div><strong>Your attire and sanctity ought to be according to your age</strong></div>
              <div><strong>Immoderate attire will only lead you to evil.</strong></div>
              <div><strong>Let your ability be in piety regulating your life and controlling your senses.</strong></div>
              <div><strong>You ought to love truth and justice.</strong></div>
              <div><strong>What earn by deceit and theft will melt like snow.</strong></div>
              <div><strong>Your profession must be according to your knowledge and age.</strong></div>
              <div><strong>Let there be no day in your life in which you did no good to others.</strong></div>
              <div><strong>Let not the insult and quarrels of others be a cause of hatred and enmity.</strong></div>
              <div><strong>Do not insult or trouble the poor.</strong></div>
              <div><strong>God decides your vocation and you choose it.</strong></div>
              <div><strong>When you choose your partner in life, choose one who has a good character and good manners</strong></div>
              <div><strong>Even if you are grown in age and maturity you have to accept your parents and submit to them</strong></div>
              <div><strong>Do not hate your own brethren.</strong></div>
              <div><strong>It is the duty of children to look after their parents.</strong></div>
              <div><strong>Do not be the cause of your parents shedding tears on account of you.</strong></div>
              <div><strong>The humble man is the greatest among men.</strong></div>
              <div><strong>Since you belong to God, you should be given back to God.</strong></div>
            </div>

          </div>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default CMCHistory;
